<template>
  <div v-show="stats !== null && Object.keys(stats).length">
    <h2
      class="flex-fJstart-fAcenter"
      @click="toggle"
    >
      Graphique
      <span
        :class="(showContenu)?'ui-icon ui-icon-carat-1-n':'ui-icon ui-icon-carat-1-s'"
        title="toggle"
      />
    </h2>

    <div v-show="showContenu">
      <div
        id="graph"
        ref="graph"
      />
      <div>
        <label class="label-connexion">
          <input
            type="checkbox"
            v-model="afficherConnexions"
            @change="updateGraph"
          >
          Connexions
        </label>
        <label class="label-commande">
          <input
            type="checkbox"
            v-model="afficherCommandes"
            @change="updateGraph"
          >
          Commandes
        </label>
        <label class="label-ca">
          <input
            type="checkbox"
            v-model="afficherCA"
          >
          Chiffres d'affaire
        </label>
        <label class="label-camoyen">
          <input
            type="checkbox"
            v-model="afficherCAMoyen"
          >
          Panier moyen
        </label>
        <label class="label-premiereco">
          <input
            type="checkbox"
            v-model="afficherPremiereCo"
          >
          Nombre de premières connexions
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from 'd3'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'stats'
    ])
  },
  mounted: function() {
    // valeur par défaut au début, rechargé ensuite : il ne faut pas que ces valeurs soient < 0 auchargement
    this.width = 100 - this.margin.left - this.margin.right
    this.height = 100 - this.margin.top - this.margin.bottom

    this.svg = d3.select('#graph')
      .append('svg')
      .attr('width', this.width)
      .attr('height', this.height + this.margin.top + this.margin.bottom)
    this.content = this.svg.append('g')
      .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')')
    this.content.append('g')
      .attr('class','botAxis')
      .attr('transform', 'translate(0,' + this.height + ')')
    this.content.append('g')
      .attr('class','leftAxis')
    this.content.append('text')
      .attr('text-anchor', 'end')
      .attr('y', 6)
      .attr('dy', '.75em')
      .attr('transform', 'rotate(-90)')
      .text('Nombre d\'occurences')
    this.content.append('g')
      .attr('class','rightAxis')
      .attr('transform', 'translate(' + (this.width - this.margin.left - this.margin.right) + ', 0)')
    this.content.append('text')
      .attr('class', 'y2text')
      .attr('text-anchor', 'end')
      .attr('y', this.width - this.margin.left - this.margin.right - 15)
      .attr('dy', '.75em')
      .attr('transform', 'rotate(-90)')
      .text('Montant en €')

    window.addEventListener('resize', this.updateGraph)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.updateGraph)
  },
  updated: function() {
    this.updateGraph()
  },
  data: function() {
    return {
      margin: { top: 10, right: 60, bottom: 30, left: 60 },
      width: 0,
      height: 0,
      svg: null,
      content: null,
      afficherConnexions: true,
      afficherCommandes: true,
      afficherCA: true,
      afficherCAMoyen: false,
      afficherPremiereCo: false,
      showContenu: true
    }
  },
  methods: {
    updateGraph: function() {
      this.resizeGraph()

      let stats = this.stats
      let formattedStats = []
      let lineCount = 0
      for (let index in stats) {
        if (this.afficherConnexions) {
          formattedStats.push({ domaine: 'connexions', libelle: stats[index].libelle, donnee: stats[index].connexions })
        }
        if (this.afficherCommandes) {
          formattedStats.push({ domaine: 'commandes', libelle: stats[index].libelle, donnee: stats[index].commandes })
        }
        if (this.afficherCA) {
          formattedStats.push({ domaine: 'ca', libelle: stats[index].libelle, donnee: stats[index].ca })
        }
        if (this.afficherCAMoyen) {
          formattedStats.push({ domaine: 'camoyen', libelle: stats[index].libelle, donnee: stats[index].camoyen })
        }
        if (this.afficherPremiereCo) {
          formattedStats.push({ domaine: 'premiereco', libelle: stats[index].libelle, donnee: stats[index].premiereco })
        }
        lineCount++
      }

      // Add X axis
      let labelGap = Math.ceil(lineCount/20)
      let x = d3.scalePoint()
        .domain(Object.keys(stats).map(function (key) { return stats[key].libelle }))
        .range([ 0, this.width - this.margin.left - this.margin.right ])
      this.content.selectAll('.botAxis')
        .transition()
        .duration(2000)
        .call(d3.axisBottom(x)
          .tickFormat(function(d, i) {
            return i % labelGap === 0 ? d : null
          })
        )

      // Add Y axis
      let y = d3.scaleLinear()
        .domain([0, Math.max(d3.max(formattedStats, function(d) { return (d.domaine !=='ca' && d.domaine !=='camoyen') ? d.donnee : 0 }), 1)])
        .range([ this.height, 0 ])
      this.content.selectAll('.leftAxis')
        .transition()
        .duration(2000)
        .call(d3.axisLeft(y))
      let y2 = d3.scaleLinear()
        .domain([0, Math.max(d3.max(formattedStats, function(d) { return (d.domaine ==='ca' || d.domaine ==='camoyen') ? d.donnee : 0 }), 1)])
        .range([ this.height, 0 ])
      this.content.selectAll('.rightAxis')
        .transition()
        .duration(2000)
        .call(d3.axisRight(y2))

      formattedStats = d3.nest() // nest function allows to group the calculation per level of a factor
        .key(function(d) { return d.domaine})
        .entries(formattedStats)

      // color palette
      let color = d3.scaleOrdinal()
        .domain(['connexions', 'commandes', 'ca', 'camoyen', 'premiereco'])
        .range(['#e41a1c','#377eb8', '#4daf4a', '#ffb233', '#ff33e9'])
      let lines = this.content.selectAll('.line')
        .data(formattedStats)

      // Draw the line
      lines.exit().remove()
      lines.enter()
        .append('path')
        .attr('class','line')
        .attr('fill', 'none')
        .merge(lines)
        .transition()
        .duration(2000)
        .attr('stroke', function(d){ return color(d.key) })
        .attr('stroke-width', 2)
        .attr('d', function(d){
          return d3.line()
            .x(function(d) { return x(d.libelle) })
            .y(function(d) { return (d.domaine === 'ca' || d.domaine ==='camoyen') ? y2(+d.donnee) : y(+d.donnee) })
            (d.values)
        })
    },
    toggle: function () {
      this.showContenu = !this.showContenu
    },
    resizeGraph: function (){
      this.width = this.$refs.graph.clientWidth - this.margin.left - this.margin.right
      this.height = this.$refs.graph.clientHeight - this.margin.top - this.margin.bottom
      this.svg
        .attr('width', this.width)
        .attr('height', this.height + this.margin.top + this.margin.bottom)
      this.content.selectAll('.botAxis')
        .attr('transform', 'translate(0,' + this.height + ')')
      this.content.selectAll('.rightAxis')
        .attr('transform', 'translate(' + (this.width - this.margin.left - this.margin.right) + ', 0)')
      this.content.selectAll('.y2text')
        .attr('y', this.width - this.margin.left - this.margin.right - 15)
    }
  },
  watch: {
    stats: function() {
      this.updateGraph()
    }
  }

}
</script>

<style>
  .label-connexion {
    color: #e41a1c;
  }
  .label-commande {
    color: #377eb8;
  }
  .label-ca {
    color: #4daf4a;
  }
  .label-camoyen {
    color: #ffb233;
  }
  .label-premiereco {
    color: #ff33e9;
  }

  #graph {
    width: 100%;
    height: 400px;
  }
</style>
